exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".details-card[data-v-5b1d6c3b]{max-width:1300px}h1[data-v-5b1d6c3b]{font-size:1.4rem}h4[data-v-5b1d6c3b]{font-size:1.2rem}", ""]);

// exports
